import { render, staticRenderFns } from "./yunnan.vue?vue&type=template&id=020419bc&"
import script from "./yunnan.vue?vue&type=script&lang=js&"
export * from "./yunnan.vue?vue&type=script&lang=js&"
import style0 from "./yunnan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports